export const darkPrimary = {
  lighter: '#34719F',
  light: '#2A5B7F',
  main: '#234C6A',
  dark: '#1C3C54',
  darker: '#152D3F',
  contrastText: '#E3E3E3',
  lighterChannel: '52 113 159',
  lightChannel: '42 91 127',
  mainChannel: '35 76 106',
  darkChannel: '28 60 84',
  darkerChannel: '21 45 63',
  contrastTextChannel: '227 227 227'
};

export const darkSecondary = {
  lighter: '#749AB5',
  light: '#527C9B',
  main: '#456882',
  dark: '#375367',
  darker: '#293E4D',
  contrastText: '#E3E3E3',
  lighterChannel: '116 154 181',
  lightChannel: '82 124 155',
  mainChannel: '69 104 130',
  darkChannel: '55 83 103',
  darkerChannel: '41 62 77',
  contrastTextChannel: '227 227 227'
};

export const darkInfo = {
  lighter: '#749AB5',
  light: '#527C9B',
  main: '#456882',
  dark: '#375367',
  darker: '#293E4D',
  contrastText: '#E3E3E3',
  lighterChannel: '116 154 181',
  lightChannel: '82 124 155',
  mainChannel: '69 104 130',
  darkChannel: '55 83 103',
  darkerChannel: '41 62 77',
  contrastTextChannel: '227 227 227'
};

export const darkAction = {
  hover: 'rgba(35 76 106 / 0.08)',
  selected: 'rgba(35 76 106 / 0.16)',
  focus: 'rgba(35 76 106 / 0.24)',
  disabled: 'rgba(69 104 130 / 0.3)',
  disabledBackground: 'rgba(69 104 130 / 0.12)',
  hoverOpacity: 0.08,
  selectedOpacity: 0.16,
  focusOpacity: 0.24,
  activatedOpacity: 0.24,
  disabledOpacity: 0.48,
  active: '#234C6A',
  activeChannel: '35 76 106',
  selectedChannel: '35 76 106'
};

export const darkCommon = {
  black: '#000000',
  white: '#FFFFFF',
  blackChannel: '0 0 0',
  whiteChannel: '255 255 255',
  background: '#1B3C53',
  onBackground: '#E3E3E3',
  backgroundChannel: '27 60 83',
  onBackgroundChannel: '227 227 227'
};

export const darkBackground = {
  paper: '#1D415B',
  default: '#1B3C53',
  neutral: '#204863',
  paperChannel: '29 65 91',
  defaultChannel: '27 60 83',
  neutralChannel: '32 72 99'
};

export const darkText = {
  primary: '#E3E3E3',
  secondary: '#9E9E9E',
  disabled: '#717171',
  primaryChannel: '227 227 227',
  secondaryChannel: '158 158 158',
  disabledChannel: '113 113 113',
  icon: 'rgba(227 227 227 / 0.7)'
};
